import script from "./property-lookup.vue?vue&type=script&setup=true&lang=ts"
export * from "./property-lookup.vue?vue&type=script&setup=true&lang=ts"

import "./property-lookup.vue?vue&type=style&index=0&id=a57657b2&lang=scss"

const __exports__ = script;

export default __exports__